<template>
  <pt-integral-particulars class="pt-integral-particulars__page"></pt-integral-particulars>
</template>

<script>
import PtIntegralParticulars from 'cps//integral-mall-manage/pt-integral-particulars/withData'
export default {
  name: 'pt-integral-particulars__view',
  components: {
    'pt-integral-particulars': PtIntegralParticulars
  }
}
</script>
